import React, { useEffect, useState, useContext } from 'react';
import Highcharts from 'highcharts';
import Axiosfetch from '../Common/Axiosfetch';
import Header from '../Header/AppHeader';
import HighchartsReact from 'highcharts-react-official';
import '../DashBoard/DashboardStyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';

const Dashboard = () => {
    const { CurrentTheme } = useContext(ThemeContext);

    const [AmountData, setAmountData] = useState([]);
    const [DateRangeData, setDateRangeData] = useState([]);
    const [QuantityData, setQuantityData] = useState([]);
    const [RecentData, setRecentData] = useState([]);

    const FetchQuotationDashboard = () => {
        Axiosfetch(baseURL + "getQuotationByDateRange", "POST", { StartDate: moment().startOf('month').format('MM/DD/YYYY, HH:mm:ss'), EndDate: moment().endOf('month').format('MM/DD/YYYY, HH:mm:ss') }, QuotationDataSuccess, Failure);
    };

    const QuotationDataSuccess = (data) => {
        var ChartAmount = [];
        var ChartDate = [];
        var ChartQuantity = [];
        var recentData = [];
        var currentGroupedDate = moment(new Date()).local().format("DD-MM-YYYY");
        var Amount = 0;
        var Quantity = 0;
        data.forEach((value, index) => {
            var groupedDate = moment(value.CreatedDate).local().format("DD-MM-YYYY");
            if (index === 0) {
                Amount = Amount + value.TotalAmount;
                Quantity = Quantity + value.TotalQuantity;
                currentGroupedDate = groupedDate;

                if (data.length === 1) {
                    ChartDate.push(moment(value.CreatedDate).local().format("DD MMMM YYYY"));
                    ChartAmount.push(Amount);
                    ChartQuantity.push(Quantity);
                    setQuantityData(ChartQuantity);
                    setAmountData(ChartAmount);
                    setDateRangeData(ChartDate);
                    Amount = 0;
                    Quantity = 0;
                }
            }
            else {
                if (currentGroupedDate === groupedDate) {
                    Amount = Amount + value.TotalAmount;
                    Quantity = Quantity + value.TotalQuantity;
                    if (index === data.length - 1) {
                        ChartDate.push(moment(data[index - 1].CreatedDate).local().format("DD MMMM YYYY"));
                        ChartAmount.push(Amount);
                        ChartQuantity.push(Quantity);
                        Amount = 0;
                        Quantity = 0;
                    }
                }
                else {
                    ChartDate.push(moment(data[index - 1].CreatedDate).local().format("DD MMMM YYYY"));
                    ChartAmount.push(Amount);
                    ChartQuantity.push(Quantity);
                    Amount = value.TotalAmount;
                    Quantity = value.TotalQuantity;

                    if (index !== data.length - 1) {
                        currentGroupedDate = groupedDate;
                    }
                    else {
                        ChartDate.push(moment(data[index].CreatedDate).local().format("DD MMMM YYYY"));
                        ChartAmount.push(Amount);
                        ChartQuantity.push(Quantity);
                        Amount = value.TotalAmount;
                        Quantity = value.TotalQuantity;
                        currentGroupedDate = groupedDate;
                    }
                }
            }

            if (index >= data.length - 5) {
                recentData.push(value);
            }
        });

        setQuantityData(ChartQuantity);
        setAmountData(ChartAmount);
        setDateRangeData(ChartDate);
        if (recentData.length > 0) {
            setRecentData(recentData.reverse());
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    useEffect(() => {
        FetchQuotationDashboard();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const options = {
        title: {
            text: 'Day Wise Quotation Amount'
        },
        credits: {
            enabled: false
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Amount (Rs)',
                align: 'high'
            },
            labels: {
                overflow: 'justify'
            }
        },
        xAxis: {
            categories: DateRangeData
        },
        plotOptions: {
            series: {
                borderRadius: 4
            }
        },
        series: [
            {
                type: 'column',
                name: "Quotation Amount",
                data: AmountData,
                color: `${CurrentTheme === "default" ? "#0094fb" : (CurrentTheme === "dark") ? "#25252B" : "#24bbc0"}`,
                dataLabels: {
                    enabled: true,
                    rotation: 0,
                    align: 'center',
                    format: '{point.y:.2f}',
                    y: 0,
                    style: {
                        fontSize: '11px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            }
        ]
    };

    const optionsProduct = {
        title: {
            text: 'Day Wise Product Quantity'
        },
        credits: {
            enabled: false
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Quantity',
                align: 'high'
            },
            labels: {
                overflow: 'justify'
            }
        },
        xAxis: {
            categories: DateRangeData
        },
        series: [
            {
                type: 'spline',
                name: "Product Quantity",
                color: `${CurrentTheme === "default" ? "#0094fb" : (CurrentTheme === "dark") ? "#25252B" : "#24bbc0"}`,
                data: QuantityData
            }
        ]
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show" style={{marginBottom:"0.8rem"}}>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Quotation DashBoard</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <h5 className="align-center">Recent Quotations</h5>

                        <ul className="list-group">
                            {
                                RecentData.length > 0 && (
                                    RecentData.map(data => (
                                        <li key={data.ID} className="list-group-item">
                                            <div>
                                                <div className={`RecentQuotation align-center ${CurrentTheme}`}><span>Quote/#{data.ID}/{moment(data.CreatedDate).local().format("DDMMYYYY")}</span></div>
                                                <div style={{ padding: "5px" }}><span style={{ fontSize: "20px" }}>Product Quantity - {data.TotalQuantity}</span></div>
                                                <div style={{ padding: "5px" }}><span style={{ fontSize: "20px" }}>Total Amount - {data.TotalAmount}</span></div>
                                            </div>

                                        </li>
                                    ))
                                )
                            }
                        </ul>
                    </div>
                    <div className="col-md-8">
                        <div className="row">
                            <div className="col-md-12">
                                <HighchartsReact highcharts={Highcharts} options={options}></HighchartsReact>
                            </div>
                            <div className="col-md-12">
                                <HighchartsReact highcharts={Highcharts} options={optionsProduct}></HighchartsReact>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Dashboard;